import React from 'react'
import map from 'lodash/map'
import './style.scss'

const SelectInput = ({ handleChange, options, style }) => (
  <select style={style} onChange={handleChange} className='option_input'>
    {map(options, (item, key) => (
      <option key={key} value={item.value}>
        {item.name}
      </option>
    ))}
  </select>
)

// TODO: use ts
// SelectInput.propTypes = {
//   handleChange: PropTypes.func,
//   style: PropTypes.object,
// }

export default SelectInput
